// Password reset page
import React, { useState } from "react";
import api from "../../utils/api";
import Button from "../../components/common/Button";
import { useNavigate, useSearchParams, Link } from "react-router-dom";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const nav = useNavigate();

  async function submit(e) {
    e.preventDefault();
    setError("");
    setMessage("");

    if (password !== confirm) {
      setError("Passwords do not match");
      return;
    }

    try {
      const res = await api.post("/auth/reset-password", {
        token,
        password,
      });

      setMessage("Password reset successful! Redirecting to login...");

      setTimeout(() => nav("/login"), 120);
    } catch (err) {
      setError("Invalid or expired token.");
    }
  }

  return (
    <div className="min-h-screen flex justify-center items-center">
      <div className="bg-white w-full max-w-md p-10 rounded-3xl shadow">
        
        <h1 className="text-3xl font-bold text-center">Set New Password</h1>
        <p className="text-gray-500 text-center">
          Enter a strong password to secure your account
        </p>

        {/* Error Message */}
        {error && (
          <div className="bg-red-100 text-red-600 p-3 mt-4 rounded-xl text-sm text-center">
            {error}
          </div>
        )}

        {/* Success Message */}
        {message && (
          <div className="bg-green-100 text-green-700 p-3 mt-4 rounded-xl text-sm text-center">
            {message}
          </div>
        )}

        <form onSubmit={submit} className="space-y-4 mt-6">
          <input
            type="password"
            required
            className="border p-3 rounded-xl w-full"
            placeholder="New password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setError("");
              setMessage("");
            }}
          />

          <input
            type="password"
            required
            className="border p-3 rounded-xl w-full"
            placeholder="Confirm password"
            value={confirm}
            onChange={(e) => {
              setConfirm(e.target.value);
              setError("");
              setMessage("");
            }}
          />

          <Button
            variant="primary"
            className="w-full py-3 text-lg"
            type="submit"
          >
            Reset Password
          </Button>
        </form>

        {/* Back to login */}
        <div className="mt-6 text-center">
          <Link to="/login" className="text-[#FF4A1F] hover:underline font-semibold">
            Back to Login
          </Link>
        </div>

      </div>
    </div>
  );
}
